import { Component, Input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { HelpersService } from "@evento-ng/libs";
import { TicketService } from "src/app/services/ticket.service";

@Component({
  selector: "app-cart-item",
  templateUrl: "./cart-item.component.html",
  styleUrls: ["./cart-item.component.scss"],
})
export class CartItemComponent {
  @Input() item: any;
  @Input() review = false;
  choosenTime = null;
  dateTimes: any;
  constructor(
    public helpers: HelpersService,
    private ticketService: TicketService,
    public translate: TranslateService
  ) {}

  ngOnInit() {
    this.dateTimes = this.item?.ticketSchedule?.timeSchedules
      ?.map((x: { time: { startAt: string; id: any } }) => {
        return {
          time: x.time.startAt,
          id: x.time.id,
        };
      })
      .sort((a: any, b: any) => {
        const timeA = this.parseTime(a.time);
        const timeB = this.parseTime(b.time);
        return timeA - timeB;
      });
  }

  parseTime(time: string): number {
    const [hours, minutes] = time.split(":").map(Number);
    return hours * 60 + minutes;
  }

  deleteItem(): void {
    this.ticketService.deleteItem(this.item);
  }

  selectTime(time: null) {
    this.choosenTime = time;
    const item = this.dateTimes.find((x: { id: any }) => x.id === time);
    console.log(item);
    this.ticketService.updateBookTicketItems({
      ...this.item,
      time: item,
    });
  }
}
